import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { NotificationCountService } from '../../../util/services/notification-count.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-notification-nav',
  templateUrl: './notification-nav.component.html',
  styleUrls: ['./notification-nav.component.css'],
  imports: [MatIconModule, MatButtonModule, MatBadgeModule, RouterModule],
})
export class NotificationNavComponent implements OnInit, OnDestroy {
  protected readonly _count = inject(NotificationCountService);

  ngOnInit(): void {
    this._count.start();
  }

  ngOnDestroy(): void {
    this._count.stop();
  }
}
